<template>
	<label
		class="app-checkbox"
		:class="{'app-checkbox--disabled' : $attrs.disabled}"
	>
		<input
			type="checkbox"
			class="app-checkbox__input"
			v-bind="$attrs"
			:checked="isChecked"
			@change="onChangeHandler"
            :required="required"
		>
		<span
			class="app-checkbox__mark"
			:class="{'app-checkbox__mark--selector' : selector}"
		></span>
		<div><slot></slot></div>
	</label>
</template>

<script>
export default {
	inheritAttrs: false,

	props: {
		modelValue: {default: ''},
		trueValue: {default: true},
		falseValue: {default: false},
		selector: Boolean,
		required: false
	},

	model: {
		prop: 'modelValue',
		event: 'change'
	},

	computed: {
		isChecked () {
			if (this.isArray) return this.modelValue.includes(this.$attrs.value)
			return this.modelValue === this.$attrs.value
		},

		isArray () {
			return this.modelValue instanceof Array
		}
	},

	methods: {
		onChangeHandler (event) {
			const checked = event.target.checked

			if (this.isArray) {
				const newVal = [...this.modelValue]
				if (checked) newVal.push(this.$attrs.value)
				else newVal.splice(newVal.indexOf(this.$attrs.value), 1)

				return this.$emit('change', newVal)
			}

			return this.$emit('change', checked ? this.trueValue : this.falseValue)
		}
	}
}
</script>

<style lang="scss" scoped>
.app-checkbox {
	display: inline-flex;
	align-items: center;
	user-select: none;
	position: relative;
	cursor: pointer;

	&__input {
		// appearance: none;
		outline: none;
		position: absolute;
		top: 0;
		left: 0;
		opacity: 0;
	}

	&__mark {
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid $default-light;
		background-color: #fff;
		height: 1em;
		width: 1em;
		border-radius: 3px;
		margin-right: 5px;
		padding-bottom: .1em;

		&:after {
			content: '';
			display: block;
			width: .2em;
			height: .4em;
			border: solid #fff;
			border-width: 0 .1em .1em 0;
			transform-origin: center;
			transform: rotate(45deg);
		}

		&--selector { border-radius: 50%; }
	}

	&__input:checked ~ &__mark {
		background-color: $primary;
		border-color: $primary;
	}

	&:hover &__mark {
		border-color: $primary;
	}

	&--disabled {
		pointer-events: none;
		opacity: 0.5;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/app-components/AppCheckbox.vue